import biLogger from '@wix/web-bi-logger';
import { StoreTemplate } from '../context/TemplateContext/TemplateContext';

const logger = biLogger.factory().logger();

export interface BiOptions {
  siteId?: string;
  originUrl?: string;
  referer?: string;
  editorSessionId: string;
}
let biOptions: BiOptions = { editorSessionId: '' };
export const setBIOptions = (data: BiOptions) => {
  biOptions = data;
};

const getLoadingTime = () => {
  if (typeof window !== 'undefined') {
    const endLoadTime = window.performance?.now();
    const startLoadTime = window.appStartLoadTime;

    if (endLoadTime && startLoadTime) {
      return endLoadTime - startLoadTime;
    }
  }

  return 0;
};

export const reportLoadSuccess = () => {
  logger.log({
    src: 2,
    evid: 43,
    openingSiteID: biOptions.siteId,
    siteType: '2',
    originappurl: biOptions.originUrl,
    loadingTime: Math.round(getLoadingTime()),
  });
};

export const reportMobileView = () => {
  logger.log({
    src: 2,
    evid: 27,
    siteType: '2',
    openingSiteId: biOptions.siteId,
    originappurl: biOptions.originUrl,
  });
};

export const reportDesktopView = () => {
  logger.log({
    src: 2,
    evid: 28,
    siteType: '2',
    openingSiteID: biOptions.siteId,
    originappurl: biOptions.originUrl,
  });
};

export const reportTabletView = () => {
  logger.log({
    src: 2,
    evid: 98,
    siteType: '2',
    openingSiteID: biOptions.siteId,
    originappurl: biOptions.originUrl,
  });
};

export const reportEditorClick = ({ origin }: { origin: 'viewer_top' | 'viewer_more' | 'edit_modal' }) => {
  logger.log({
    src: 2,
    evid: 15,
    origin,
    esi: biOptions.editorSessionId,
    originappurl: biOptions.originUrl,
    openingSiteID: biOptions.siteId!,
    siteType: 2,
    template_type: 'Editor',
  });
};

export const reportInfoClick = () => {
  logger.log({
    src: 2,
    evid: 19,
    siteType: '2',
    openingSiteId: biOptions.siteId,
    originappurl: biOptions.originUrl,
  });
};

export const reportStudioTemplateEdit = ({ template }: { template: StoreTemplate }) => {
  logger.log({
    src: 2,
    evid: 901,
    action: 'edit',
    template_id: template.templateId,
    origin: biOptions.referer || '',
    tab_name: 'viewer',
    title: template.title,
    slug_id: template.slug,
  });
};

export const modalShown = () => {
  logger.log({
    src: 2,
    evid: 115,
    template_id: biOptions.siteId || null,
    modal_name: 'template_superbowl',
  });
};
